export interface Testimonial {
  id: string
  name: string
  role: string
  company: string
  avatar: string
  content: string
  verified: boolean
}

export const testimonials: Testimonial[] = [
  {
    id: '1',
    name: 'Marcus T.',
    role: 'Investor',
    company: 'Atlanta, GA',
    avatar:
      'https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    content:
      "Closed my first deal within 3 weeks of signing up. Didn't expect it to work that fast honestly.",
    verified: true,
  },
  {
    id: '2',
    name: 'Sarah C.',
    role: 'Wholesaler',
    company: 'Houston, TX',
    avatar:
      'https://images.unsplash.com/photo-1607746882042-944635dfe10e?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    content:
      'This replaced like 20 hours a week of manual work for me. I actually have my weekends back now.',
    verified: true,
  },
  {
    id: '3',
    name: 'David R.',
    role: 'Fix & Flip',
    company: 'Phoenix, AZ',
    avatar:
      'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    content:
      "Was skeptical but my response rate literally tripled. The offers don't sound like spam which I think is the difference.",
    verified: true,
  },
  {
    id: '4',
    name: 'Jen M.',
    role: 'Firm Owner',
    company: 'Dallas, TX',
    avatar:
      'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    content:
      'We run 3 markets now with the same team size. Would not have been possible before this.',
    verified: true,
  },
  {
    id: '5',
    name: 'Rob K.',
    role: 'Investor',
    company: 'Seattle, WA',
    avatar:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    content:
      'One deal paid for like 3 years of the subscription. Not every month is a home run but the pipeline stays full.',
    verified: true,
  },
  {
    id: '6',
    name: 'Amanda F.',
    role: 'Buy & Hold',
    company: 'Memphis, TN',
    avatar:
      'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    content:
      "I was losing leads left and right before this. Now everything's in one place and I actually follow up on time.",
    verified: true,
  },
  {
    id: '7',
    name: 'James W.',
    role: 'Investor',
    company: 'Charlotte, NC',
    avatar:
      'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    content:
      'The auto follow-ups alone are worth it. I used to forget to call people back and it was costing me deals.',
    verified: true,
  },
  {
    id: '8',
    name: 'Lisa P.',
    role: 'Flipper',
    company: 'Tampa, FL',
    avatar:
      'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    content:
      'Found 2 off-market properties my first month that I never would have seen otherwise. Pretty wild.',
    verified: true,
  },
  {
    id: '9',
    name: 'Mike B.',
    role: 'Rental Investor',
    company: 'Indianapolis, IN',
    avatar:
      'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    content:
      'Added 5 doors to my portfolio this year. Spend way less time prospecting and more time on the actual properties.',
    verified: true,
  },
  {
    id: '10',
    name: 'Emily T.',
    role: 'Wholesaler',
    company: 'Columbus, OH',
    avatar:
      'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    content:
      "Closing rate went way up. I think it's because the offers actually sound like a real person wrote them.",
    verified: true,
  },
  {
    id: '11',
    name: 'Dan L.',
    role: 'Analyst',
    company: 'Denver, CO',
    avatar:
      'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    content:
      "The data and analytics are really solid. We can actually see what's working and what's not by market.",
    verified: true,
  },
  {
    id: '12',
    name: 'Rachel S.',
    role: 'Investor',
    company: 'Nashville, TN',
    avatar:
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    content:
      'Honestly just nice to have something that works without babysitting it. Set it up and it runs.',
    verified: true,
  },
]
